"use strict";
var globalThis = require("../internals/global-this");
var fails = require("../internals/fails");
var RegExp = globalThis.RegExp;
var FLAGS_GETTER_IS_CORRECT = !fails(function() {
  var INDICES_SUPPORT = true;
  try {
    RegExp(".", "d");
  } catch (error) {
    INDICES_SUPPORT = false;
  }
  var O = {};
  var calls = "";
  var expected = INDICES_SUPPORT ? "dgimsy" : "gimsy";
  var addGetter = function(key2, chr) {
    Object.defineProperty(O, key2, { get: function() {
      calls += chr;
      return true;
    } });
  };
  var pairs = {
    dotAll: "s",
    global: "g",
    ignoreCase: "i",
    multiline: "m",
    sticky: "y"
  };
  if (INDICES_SUPPORT) pairs.hasIndices = "d";
  for (var key in pairs) addGetter(key, pairs[key]);
  var result = Object.getOwnPropertyDescriptor(RegExp.prototype, "flags").get.call(O);
  return result !== expected || calls !== expected;
});
module.exports = { correct: FLAGS_GETTER_IS_CORRECT };
